import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.OtherRequirement,
	portal: 'SP',
};

const basePath = 'Catalogs|Other Requirement|Instructions|';

export type SPOtherRequirementInstructionsLocNames =
	| 'SPOtherRequirementInstructionsPageTitle'
	| 'SPOtherRequirementInstructionsSectionTitle'
	| 'SPOtherRequirementInstructionsButtonEdit'
	| 'SPOtherRequirementInstructionsButtonCancel'
	| 'SPOtherRequirementInstructionsButtonUpdate'
	| 'SPOtherRequirementInstructionsFieldLabelInstructions'
	| 'SPOtherRequirementInstructionsFieldLabelDeleteInstructions'
	| 'SPOtherRequirementInstructionsNotificationMessageSuccess';

export const spOtherRequirementInstructionsLocs: LocDefs<SPOtherRequirementInstructionsLocNames> = {
	SPOtherRequirementInstructionsPageTitle: {
		defaultValue: 'Other Requirements Instructions',
		description: 'The page title for the other requirements instructions.',
		displayPath: `${basePath}Page Title`,
		displayType: 'Title',
		legacyName: 'OtherRequirement/Catalogs.OtherRequirement.Instructions.TabTitle',
		...sharedProperties,
	},
	SPOtherRequirementInstructionsNotificationMessageSuccess: {
		defaultValue: 'Changes saved',
		description: 'The success message for the other requirements instructions.',
		displayPath: `${basePath}Success Message`,
		displayType: 'Notification',
		legacyName:
			'OtherRequirement/Catalogs.OtherRequirement.Instructions.NotificationMessage.Success',
		...sharedProperties,
	},
	SPOtherRequirementInstructionsSectionTitle: {
		defaultValue: 'Instructions',
		description: 'The section title for the other requirements instructions.',
		displayPath: `${basePath}Section Title`,
		displayType: 'Title',
		legacyName: 'OtherRequirement/Catalogs.OtherRequirement.Instructions.Title.Instructions',
		...sharedProperties,
	},
	SPOtherRequirementInstructionsButtonEdit: {
		defaultValue: 'Edit',
		description: 'The edit button label for the other requirements instructions.',
		displayPath: `${basePath}Button Edit`,
		displayType: 'Button',
		legacyName: 'OtherRequirement/Catalogs.OtherRequirement.Instructions.Button.Edit',
		...sharedProperties,
	},
	SPOtherRequirementInstructionsButtonCancel: {
		defaultValue: 'Cancel',
		description: 'The cancel button label for the other requirements instructions.',
		displayPath: `${basePath}Button Cancel`,
		displayType: 'Button',
		legacyName: 'OtherRequirement/Catalogs.OtherRequirement.Instructions.Button.Cancel',
		...sharedProperties,
	},
	SPOtherRequirementInstructionsButtonUpdate: {
		defaultValue: 'Update',
		description: 'The update button label for the other requirements instructions.',
		displayPath: `${basePath}Button Update`,
		displayType: 'Button',
		legacyName: 'OtherRequirement/Catalogs.OtherRequirement.Instructions.Button.Update',
		...sharedProperties,
	},
	SPOtherRequirementInstructionsFieldLabelInstructions: {
		defaultValue: 'Instructions',
		description: 'The label for the Instructions field in the other requirements instructions.',
		displayPath: `${basePath}Field Label Instructions`,
		displayType: 'Label',
		legacyName:
			'OtherRequirement/Catalogs.OtherRequirement.Instructions.FieldLabel.Instructions',
		...sharedProperties,
	},
	SPOtherRequirementInstructionsFieldLabelDeleteInstructions: {
		defaultValue: 'Delete instructions',
		description:
			'The label for the Delete Instructions checkbox in the other requirements instructions.',
		displayPath: `${basePath}Field Label Delete Instructions`,
		displayType: 'Label',
		legacyName:
			'OtherRequirement/Catalogs.OtherRequirement.Instructions.FieldLabel.DeleteInstructions',
		...sharedProperties,
	},
};

export type SPOtherRequirementInstructionsLocType = LocMap<SPOtherRequirementInstructionsLocNames>;
